export default __webpack_public_path__ + "fonts/glass_element_6041fbf99112eb35a632ff4219c0c7ab.svg";